import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../configureStore';

export const versionStateSelector = ({ entities }: RootState) => entities.version;

export const getVersionsForObject = createSelector(
  [versionStateSelector, (_state: RootState, objectid: string) => objectid],
  ({ versions }, objectid) => versions[objectid] ?? [],
);

export const getVersionsHasMore = createSelector(
  [versionStateSelector, (_state: RootState, objectid: string) => objectid],
  ({ hasMore }, objectid) => hasMore[objectid] ?? false,
);

export const getAssociatedVersionsForObject = createSelector(
  [versionStateSelector, (_state: RootState, objectid: string) => objectid],
  ({ associatedVersions }, objectid) => associatedVersions[objectid] ?? [],
);

export const getAssociatedVersionsHasMore = createSelector(
  [versionStateSelector, (_state: RootState, objectid: string) => objectid],
  ({ associatedHasMore }, objectid) => associatedHasMore[objectid] ?? false,
);

export const getVersionsIsLoading = createSelector(
  versionStateSelector,
  ({ isLoading }) => isLoading,
);

export const getVersionsIsRestoring = createSelector(
  versionStateSelector,
  ({ isRestoring }) => isRestoring,
);

export const getVersionData = createSelector(
  [versionStateSelector, (_state: RootState, versionid: string) => versionid],
  ({ versionData }, versionid) => versionData[versionid],
);

export const getAssociatedVersionData = createSelector(
  [versionStateSelector, (_state: RootState, versionid: string) => versionid],
  ({ associatedVersionData }, versionid) => associatedVersionData[versionid],
);
